import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const SelectWrapper = styled.div`
  width: auto;

  ${mediaQueries.laptop} {
    width: 240px;
  }
`
